import { Locale } from 'shared/i18n/interface'
import { State as CurrentDesignState } from '~/app/features/Gallery/components/PreviewArea/GalleryQuickView/hooks/useCurrentDesign'
import { useBatchEstimatedPricing } from './useBatchEstimatedPricing'
import { usePricingContext } from '~/app/features/FragmentRoot/contexts/pricing/context'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'
import type { State } from 'shared/types/gallery/state'
import type { PCT } from 'shared/types/vp/pct'

export interface UseProductOptionsTrackingInput {
  currentEntity: CurrentDesignState
  startingEntity: State.TileEntity
  locale: Locale
  market: string
  quantity: GalleryModelsUrl.ValidParsedQsValue<number>
  enabled?: boolean
}

export interface UseProductOptionsTrackingOutput {
  initialEstimatedPriceData: PCT.Models.ProductCatalogPricingService.QuantitiesPricingResult | null | undefined
  currentEstimatedPriceData: PCT.Models.ProductCatalogPricingService.QuantitiesPricingResult | null | undefined
}

export const useProductOptionsTracking = (props: UseProductOptionsTrackingInput): UseProductOptionsTrackingOutput => {
  const { currentEntity, startingEntity, locale, market, quantity, enabled = true } = props
  const pricingContext = usePricingContext()
  const encodedContextString = pricingContext?.getEncodedContextString()

  const { data: initialEstimatedPriceData } = useBatchEstimatedPricing(
    {
      market,
      productKey: startingEntity.productKey,
      quantities: quantity ? [quantity] : [],
      productVersion: startingEntity.productVersion,
      pricingContext: encodedContextString,
      selections: startingEntity.productOptions,
      locale,
      vatInc: false,
    },
    { enabled },
  )

  const { data: currentEstimatedPriceData } = useBatchEstimatedPricing(
    {
      market,
      productKey: currentEntity.productKey,
      quantities: quantity ? [quantity] : [],
      productVersion: currentEntity.productVersion,
      pricingContext: encodedContextString,
      selections: currentEntity.productOptions,
      locale,
      vatInc: false,
    },
    { enabled },
  )

  return {
    initialEstimatedPriceData,
    currentEstimatedPriceData,
  }
}
